import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate, useParams } from 'react-router-dom';

export default function ProcessedFoodbgEdit() {
    const history = useNavigate();

  const [file10, setFile10] = useState(null);
  const [inputval10, setinputVal10] = useState({
    ProcessedFoodBgimg:"",
    fname10: "",
    date: "",
  });

  const setData = (e) => {
    const { name, value } = e.target;
    setinputVal10((Data) => {
      return {
        ...Data,
        [name]: value,
      };
    });
  };
  const { id } = useParams("");
  console.log(id);
  const getData = async () => {
    const res10 = await fetch(`https://pratik-agro-backend.vercel.app/getProcessedFoodBgimg/${id}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    });
    const data3 = await res10.json();

    if (res10.status === 422 || !data3) {
      console.log("error");
    } else {
      console.log(data3);
    setinputVal10({
        ProcessedFoodBgimg: data3.ProcessedFoodBgimg,
      fname10: data3.fname10,
      date: data3.date,
    });
  }
  };
  useEffect(() => {
    getData();
  }, []);

  const updateData8 = async (e) => {
    e.preventDefault();

    console.log(inputval10);

    var formData8 = new FormData();
    if (file10 != null) {
      formData8.append("image10", file10);
    }
    formData8.append("fname10", inputval10.fname10);
    formData8.append("date", inputval10.date);

    for (var pair of formData8.entries()) {
      console.log(pair[0] + ", " + pair[1]);
    }

    const config = {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    };

    axios
      .post(`https://pratik-agro-backend.vercel.app/updateProcessedFoodBgimg/${id}`, formData8, config)
      .then((res) => {
        if (res.status === 201) {
          console.log(res.data);
          history("/ProcessedfoodBg");
        }
      })
      .catch((error) => {
        if (error.response) {
          console.log(error.response);
        }
      });
  };
  return (
    <div className='content'>
         <div className="container mt-5 ">
          <Link className="btn btn-dark" to="/ProcessedfoodBg">
          <i class="bi bi-arrow-left-circle-fill"></i>
          </Link>
        </div>

        <form className="mx-auto mt-5 shadow p-5">
          <div className="container ">
            <h6>Fill This Form:-</h6>
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Background Image:</label>
            <input
              type="file"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="image10"
              onChange={(e) => setFile10(e.target.files[0])}
              value={inputval10.image10}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Background Image Name: :</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              name="fname10"
              onChange={setData}
              value={inputval10.fname10}
            />
          </div>
          <div className="mb-3 w-50 ">
            <label className="form-label">Date:</label>
            <input
              type="text"
              className="form-control"
              id="exampleInputEmail1"
              aria-describedby="emailHelp"
              name="date"
              onChange={setData}
              value={inputval10.date}
            />
          </div>
          <div>
            <Link className="btn btn-success  mt-3" onClick={updateData8}>
              update Detail
            </Link>
          </div>
        </form>
    </div>
  )
}
